import React from 'react';
import { Link } from 'react-router-dom';
import footerLogo from "../../assets/images/resources/footer-logo.png"

function Main() {
  return (
    <div>
      <footer className="site-footer site-footer-two">
        <div className="footer-main footer-main-two">
          <div className="container">
            <div className="row">
              <div className="col-xl-2 col-lg-4 col-md-5 col-sm-5">
                <div
                  className="footer-widget footer-widget-link footer-widget-link-two wow fadeInLeft animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="500ms"
                >
                  <h4 className="footer-widget-title">Quick Link</h4>
                  <ul className="footer-widget-link-details">
                    <li>
                      <Link to="/service">Popular Services</Link>
                    </li>
                    <li>
                      <Link to="/team-member">Team Member</Link>
                    </li>
                    <li>
                      <Link to="/contact">Privacy &amp; Setting</Link>
                    </li>
                    <li>
                      <Link to="/package">Pricing Package</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-4 col-lg-8 col-md-7 col-sm-7">
                <div
                  className="footer-widget footer-widget-address footer-widget-address-two wow fadeInLeft animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <h4 className="footer-widget-title">Get In Touch</h4>
                  <ul className="footer-widget-address-details">
                    <li>
                      <i className="icon-location" />
                      <p>
                        55 Main Street, 2nd block <br />
                        Malborne, Australia
                      </p>
                    </li>
                    <li>
                      <i className="icon-sms-box" />
                      <Link to="/mailto:support@gmail.com">support@gmail.com</Link>
                    </li>
                    <li>
                      <i className="icon-call-icon" />
                      <Link
                        to="/tel:+000(123)45688"
                        className="footer-widget-number"
                      >
                        +000 (123) 456 88
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div
                  className="footer-widget footer-widget-newsletter footer-widget-newsletter-two wow fadeInLeft animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <h4 className="footer-widget-title">Newsletter</h4>
                  <p className="footer-widget-newsletter-detail">
                    Get more update to join Us
                  </p>
                  <form action="#" className="newsletter-email-box">
                    <input
                      type="email"
                      id="email"
                      name="EMAIL"
                      placeholder="Email Address"
                    />
                    <button className="newsletter-send-box">
                      Sign Up
                      <i className="icon-right-arrow" />
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom footer-bottom-two">
          <div className="container">
            <div
              className="footer-bottom-inner footer-bottom-inner-two wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <div className="footer-bottom-inner-two-logo">
                <Link to="/">
                  <img
                    src={footerLogo}
                    alt="logo-two"
                  />
                </Link>
              </div>
              <ul className="footer-bottom-inner-item footer-bottom-inner-item-two">
                <li>
                  <Link to="/faq">FAQs</Link>
                </li>
                <li>
                  <Link to="/about">Company</Link>
                </li>
                <li>
                  <Link to="/contact">Feedback</Link>
                </li>
                <li>
                  <Link to="/contact">History</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
              <div className="copyright">
                <p>
                  © 2024 · <Link to="/">Zoso</Link>, All Rights Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Main
